export default function ResearchNotice({ content }) {
  return (
    <section className="w-full bg-gray-50 py-10 px-6">
      <div className="max-w-[700px] mx-auto bg-white border border-gray-200 rounded-lg text-center px-8 py-6">
        <div className="flex items-center justify-center gap-2 mb-2">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            className="text-teal-500"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
            <path
              d="M12 11v5M12 8h.01"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <h3 className="text-gray-800 font-semibold text-[15px]">
             {content?.researchNoticeTitle || "Research Use Only"}
          </h3>
        </div>

        <p className="text-gray-500 text-[13px] leading-relaxed">
           {content?.researchNoticeText || "For laboratory research purposes only. Not intended for human or animal use. To be handled by trained professionals in controlled laboratory environments."}
        </p>
      </div>
    </section>
  );
}